import { render, staticRenderFns } from "./BlogEntries.vue?vue&type=template&id=2b5b5f90"
import script from "./BlogEntries.vue?vue&type=script&lang=ts"
export * from "./BlogEntries.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports